// @flow
type GraphQlErrors = {
  graphQLErrors: null | Array<{
    message: string,
    path: Array<string>,
    locations: Array<{
      line: number,
      column: number
    }>
  }>
};

const getGraphQlErrorsByPath = (errors: GraphQlErrors, matchPath: string) => {
  return (
    errors?.graphQLErrors?.filter(({ path }) => path.join(".") === matchPath) ||
    []
  );
};

export default getGraphQlErrorsByPath;
